import React, { useEffect, useState } from "react";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import FactorListTabel from "../../Tables/Factor/FactorListTabel";
import {
  cancelFactureApi,
  getFactorListApi,
  getFactorTransactionDetailApi,
} from "../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import { Modal } from "react-bootstrap";
import Button from "../../Button/Button";
import UserInfo from "../../Modal/Information/UserInfo/UserInfo";
import FactorTransactionDetail from "../../Tables/Factor/FactorTransactionTable";

const FactorListContainer = () => {
  const [modalState, setModalState] = useState(false);
  const [userModalState, setUserModalState] = useState(false);
  const [selectedDataState, setSelectedDataState] = useState();
  const [factorListState, setFactorListState] = useState([]);
  const [paymentModalState, setPaymentModalState] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentDetailState, setPaymentDetailState] = useState(null);
  const paymentDetailHandler = (record) => {
    setPaymentModalState(true);
    setPaymentLoading(true);
    setPaymentDetailState(null);

    getFactorTransactionDetailApi(record.id, (res) => {
      setPaymentLoading(false);
      setPaymentDetailState(res);
    });
  };
  useEffect(() => {
    getFactorListHandler();
  }, []);
  const getFactorListHandler = () => {
    getFactorListApi((res) => {
      if (res.status === 1) {
        setFactorListState(
          res.facture
            .filter((item) => item.user_type === "admin")
            .sort((a, b) => b.id - a.id),
        );
      } else {
        errorToast(res.message);
      }
    });
  };
  const cancelFactureHandler = () => {
    let Info = {
      id: selectedDataState.id,
      status: -1,
    };
    cancelFactureApi(Info, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          succToast("با موفقیت کنسل شد");
          setModalState(false);
          getFactorListHandler();
        } else {
          errorToast(res.message);
        }
      } else {
        console.error(res);
      }
    });
  };
  const openModalHandler = (type) => {
    if (type === "user") {
      setUserModalState(true);
      return;
    }
    setModalState(true);
  };
  return (
    <div className="w-100 bg-white d-flex flex-column align-items-center py-3">
      <TableFixedPage title={"لیست فاکتور های ایجاد شده"} />
      <Modal show={modalState} onHide={() => setModalState(false)}>
        <Modal.Header>
          <Modal.Title
            style={{ fontSize: "1rem", width: "100%", direction: "rtl" }}
          >
            آیا از لغو فاکتور موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={() => setModalState(false)}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={cancelFactureHandler}
              //   disabledProps={disableRemove}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={userModalState} onHide={() => setUserModalState(false)}>
        <Modal.Header>
          <Modal.Title
            style={{ fontSize: "1rem", width: "100%", direction: "rtl" }}
          >
            اطلاعات مشتری
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserInfo
            Info={{
              ...selectedDataState,
              userId: selectedDataState?.assigned_user_id,
            }}
            showAddress={true}
            handleOk={() => setUserModalState(false)}
          />
        </Modal.Body>
      </Modal>
      <Modal
        show={paymentModalState}
        onHide={() => setPaymentModalState(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              fontSize: "1rem",
              width: "100%",
              direction: "rtl",
            }}
          >
            جزئیات پرداخت فاکتور
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ direction: "rtl" }}>
           <FactorTransactionDetail
    data={paymentDetailState}
    loading={paymentLoading}
  />
        </Modal.Body>
      </Modal>
      <FactorListTabel
        data={factorListState}
        modalHandler={(e, type) => {
          setSelectedDataState(e);
          openModalHandler(type);
        }}
        paymentDetailHandler={paymentDetailHandler}
      />
    </div>
  );
};

export default FactorListContainer;
